// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewAcuityEyesResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewAcuityEyesResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	od!: string | null;

	@GandalfProperty({ designType: String })
	odModifier!: string | null;

	@GandalfProperty({ designType: String })
	os!: string | null;

	@GandalfProperty({ designType: String })
	osModifier!: string | null;

	@GandalfProperty({ designType: String })
	ou!: string | null;

	@GandalfProperty({ designType: String })
	ouModifier!: string | null;

}
